import { ajaxGetJson, ajaxPostJson, setParams } from './ajax';
import url from './url'

// QA检测
export const transFileSentQA = (params) => {
  return ajaxPostJson(`/file/loadEditSentPairFileByPage`, params);
};
//处理修订痕迹
export const processSentRevisionTraces = (params) => {
  return ajaxPostJson(`/file/processSentRevisionTraces`, params);
}
// 获取文件相关信息
export const taskInfoAjax = (params) => {
  return ajaxPostJson(`/${url.FILEINFO}`, params);
};

//获取任务的相关信息
export const taskInfoAjax2 = (params) => {
  return ajaxPostJson(`/${url.FILETASKINFO}`, params);
};

//获取任务进度
export const taskProgressAjax = (params) => {
  return ajaxPostJson(`/${url.TASKPROGRESS}`, params);
};

// 获取文件内容
export const fileContentAjax = (params) => {
  return ajaxPostJson(`/${url.FILECONTENT}`, params);
};

//获取任务内容
export const taskContentAjax = (params) => {
  return ajaxPostJson(`/${url.TASKCONTENT}`, params);
};

//获取原文或者译文预览
export const filePreviewAjax = (params) => {
  return ajaxPostJson(`/${url.FILEPREVIEW}`, params);
};

//文件检测QA
export const fileQACheckAjax = (params) => {
  return ajaxGetJson(`/${url.FILECHECK}?fileId=${params.fileId}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
};

//文件检测结果QA
export const fileQACheckResultAjax = (params) => {
  return ajaxGetJson(`/${url.FILECHECKRESULT}?taskKey=${params.taskKey}&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
};

//添加当前备注
export const fragmentAddRemarksAjax = (params) => {
  return ajaxPostJson(`/${url.ADDFRAGNENTMARKS}`, params);
};

//获取当前备注
export const fragmentGetRemarksAjax = (params) => {
  return ajaxPostJson(`/${url.CURRENTREMARKSINFO}`, params);
};

//删除批注
export const fragmentRemarksDeleteAjax = (params) => {
  return ajaxPostJson(`/${url.CURRENTREMARKSDELETE}`, params);
};

//更新批注
export const fragmentRemarksUpdateAjax = (params) => {
  return ajaxPostJson(`/${url.CURRENTREMARKSUPDATE}`, params);
};

//修改译文
export const updateTargetAjax = (params) => {
  return ajaxPostJson(`/${url.FILEREUPDATETARGET}`, params);
};

//修改记录
export const modifyRecordAjax = (params) => {
  return ajaxPostJson(`/${url.MODIFYRECORD}`, params);
};

//获取片段的记忆库
export const sentMemoryAjax = (params) => {
  return ajaxPostJson(`/${url.SENTMEMORYLIST}`, params);
};
//获取任务是否完成状态
export const getTaskStatusAjax = (params) => {
  return ajaxPostJson(`/fileTask/getFileTaskStatus`, params);
};
//获取片段的术语库
export const sentTermAjax = (params) => {
  return ajaxPostJson(`/${url.SENTTERMLIST}`, params);
};

//翻译查词
export const dictTranslateAjax = (params) => {
  return ajaxPostJson(`/${url.DICTTRANXLATE}`, params);
};

//编辑译文后将内容添加的记忆库中
export const editorAddMemoryAjax = (params) => {
  return ajaxPostJson(`/${url.EDITORADDMEMORY}`, params);
};

//片段的重新机翻
export const afreshTranslateAjax = (params) => {
  return ajaxGetJson(`/${url.UPDATE_TRANSLATION}?sid=${params.sid}&companyCode=${params.companyCode}&fileId=${params.fileId}&platformType=${params.platformType}`, params);
};

export const afreshTranslateAjax2 = (params) => {
  return ajaxGetJson(`/${url.AFRESHTRANSLATE}?sid=${params.sid}&companyCode=${params.companyCode}&taskType=${params.taskType}&fileId=${params.fileId}&platformType=${params.platformType}`, params);
};
export const getMachineTranslation = (params) => {
  return ajaxGetJson(`/${url.getMachineTranslation}?sid=${params.sid}&companyCode=${params.companyCode}&taskType=${params.taskType}&fileId=${params.fileId}&platformType=${params.platformType}`, params);
};

//合并句子
export const mergeFragmentAjax = (params) => {
  return ajaxPostJson(`/${url.MERGEFRANGMENT}`, params);
};

//拆分句子
export const splitFragmentAjax = (params) => {
  return ajaxPostJson(`/${url.FRANGMENTSPLIT}`, params);
};

//查找文章内术语的个数
export const searchTermNumberAjax = (params) => {
  return ajaxPostJson(`/${url.TERMNUMBER}`, params);
};

//自动填充译文的tag标记
export const autoFillTagAjax = (params) => {
  let path = null;
  if (Reflect.has(params, 'taskKey') && (params.taskKey)) {
    path = `/${url.AUTOMATIC}?fileId=${params.fileId}&companyCode=${params.companyCode}&platformType=${params.platformType}&taskKey=${params.taskKey}`
  } else {
    path = `/${url.AUTOMATIC}?fileId=${params.fileId}&companyCode=${params.companyCode}&platformType=${params.platformType}`
  }
  if (Reflect.has(params, 'taskType') && params.taskType === 'school' && path) {
    path += `&taskId=${params.taskId}`
  }
  return ajaxGetJson(path, params);
};

//提交任务
export const submitTaskAjax = (params) => {
  return ajaxPostJson(`/${url.SUBMITTASK}`, params);
};

//更新句子的状态
export const updataSentStatusAjax = (params) => {
  return ajaxPostJson(`/${url.UPDATESTATUS}`, params);
};

//获取句子的批注状态
export const remarkStatusAjax = (params) => {
  return ajaxPostJson(`/${url.REMARKSTATE}`, params);
};

//添加术语库
export const addTermSentAjax = (params) => {
  return ajaxPostJson(`/${url.ADDTERMTAGTARGET}`, params);
};

//高校编辑器内容
export const schoolTaskContentAjax = (params) => {
  return ajaxPostJson(`/${url.SCHOOLTASKINFO}`, params);
};

//获取QA检测的列表
export const QACheckFileTaskAjax = (params) => {
  return ajaxPostJson(`/${url.QACHECKLIST}`, params);
};

//忽略QA检测
export const ignoreQAFileTaskAjax = (params) => {
  return ajaxPostJson(`/${url.IGNOREQA}`, params);
};

//恢复QA
export const recoveryQAFileTaskAjax = (params) => {
  return ajaxPostJson(`/${url.RECOVERYQA}`, params);
};

//获取项目信息
export const projectInfoAjax = (params) => {
  return ajaxPostJson(`/${url.PROJECTINFO}`, params);
};

//单句QA检测
export const fileSentQAAjax = (params) => {
  return ajaxGetJson(`/${url.FILESENTQA}/?companyCode=${params.companyCode}&platformType=${params.platformType}&fileId=${params.fileId}&taskId=${params.taskId}&sentId=${params.sentId}`, params);
};

//获取上下对照数据
export const getCombineTopfileAjax = (params) => {
  console.log(params)
  if (params.type == 'project') {
    return ajaxGetJson(`/${url.CombineTopfile}/?fileId=${params.fileId}&partIndex=${params.partIndex}&marker=${params.marker}&taskType=${params.taskType}&comparedHighlight=1&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
  } else {
    return ajaxGetJson(`/${url.CombineTopfile}/?fileId=${params.fileId}&partIndex=${params.partIndex}&marker=${params.marker}&taskType=${params.taskType}&taskId=${params.taskId}&comparedHighlight=1&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
  }

}
//获取左右对照数据
export const getCombineLeftfileAjax = (params) => {
  if (params.type == 'project') {
    return ajaxGetJson(`/${url.CombineLeftfile}/?fileId=${params.fileId}&partIndex=${params.partIndex}&marker=${params.marker}&taskType=${params.taskType}&comparedHighlight=1&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
  } else {
    return ajaxGetJson(`/${url.CombineLeftfile}/?fileId=${params.fileId}&partIndex=${params.partIndex}&marker=${params.marker}&taskType=${params.taskType}&taskId=${params.taskId}&comparedHighlight=1&platformType=${params.platformType}&companyCode=${params.companyCode}`, params);
  }
}

// 点击获取索引
export const editorSentHighlight = (params) => {
  return ajaxPostJson(`/${url.editorSentHighlight}`, params);
}

// 添加术语表
export const addTermSentUpdateTagTargetV2 = (params) => {
  return ajaxPostJson(`${url.addTermSentUpdateTagTargetV2}`, params);
}
// 获取术语表
export const queryTemporaryPage = (params) => {
  params.filter = setParams(params.filter);
  return ajaxPostJson(`${url.queryTemporaryPage}`, params);
}
//修改术语表
export const termSentUpdate = (params) => {
  return ajaxPostJson(`${url.termSentUpdate}`, params);
}
// 删除术语表
export const batchDeleteByIdList = (params) => {
  return ajaxPostJson(`${url.batchDeleteByIdList}`, params);
}
// 保存至术语库
export const saveTemporaryTermLib = (params) => {
  return ajaxPostJson(`${url.saveTemporaryTermLib}`, params);
}
// 退回重做
export const updateFinish = (params) => {
  return ajaxPostJson(`${url.updateFinish}`, params);
}
// 查看评分/分数
export const queryTaskScoreAndEval = (params) => {
  return ajaxPostJson(`${url.queryTaskScoreAndEval}`, params);
}
// 批改作业 老师评价
export const insertTaskManualScore = (params) => {
  return ajaxPostJson(`${url.insertTaskManualScore}`, params);
}
//获取译文句子为空
export const getcountTargetSentIsNull = (params) => {
  return ajaxPostJson(`${url.countTargetSentIsNull}`, params);
}
// 获取退回任务列表
export const getQueryRollBackTask = (params) => {
  return ajaxPostJson(`${url.QUERYROLLBACKTASK}`, params);
}
// 确认退回
export const rollBackTaskToSent = (params) => {
  return ajaxPostJson(`${url.ROLLBACKTASKTOSENT}`, params);
}
// 项目经理确认退回任务
export const rollBackTask = (params) => {
  return ajaxPostJson(`${url.ROLLBACKTASK}`, params);
}
// 项目经理确认验收
export const acceptanceTask = (params) => {
  return ajaxPostJson(`${url.ACCEPTANCETASK}`, params);
}
//翻译详情保存修改
export const updateBatchSentence = (params) => {
  return ajaxPostJson(`${url.UPDATEBATCHSENTENCE}`, params);
}
//解锁单个句子
export const unLockOneAjax = (params) => {
  return ajaxPostJson(`${url.DEBLOCKING}`, params);
}
//解锁全部句子
export const unLockAllAjax = (params) => {
  return ajaxPostJson(`${url.DEBLOCKALL}`, params);
}
//取消确认(编辑器取消打勾)
export const cancelConfirmationAjax = (params) => {
  return ajaxPostJson(`${url.CANCELCONFIRMATION}`, params);
}
//发送消息
export const sendMsg = (params) => {
  return ajaxPostJson(`/file/sendTransEditMessage`, params);
}
